import styled from 'styled-components';

import { typographyV2 } from '~/design-tokens/typography/Typography.styles';

export const ChartSVG = styled.svg`
  color: var(--text-soft);
`;

export const TimeSeriesLine = styled.path<{ $isBullish: boolean }>`
  fill: none;
  stroke: ${({ $isBullish }) =>
    $isBullish ? 'var(--viz-bullish)' : 'var(--viz-bearish)'};
  stroke-width: 1px;
`;

export const TargetLine = styled.path<{
  $variant: 'high' | 'average' | 'low';
  $isBearish: boolean;
}>`
  fill: none;
  stroke: ${({ $isBearish }) =>
    $isBearish ? 'var(--viz-bearish)' : 'var(--viz-bullish)'};
  stroke-width: 1px;
  stroke-dasharray: ${({ $variant }) =>
    $variant === 'average' ? '4 4' : 'none'};
`;

export const DividerLine = styled.line`
  stroke: var(--border-soft);
  stroke-dasharray: 2 2;
  stroke-width: 1px;
`;

export const AxisLine = styled.line`
  stroke: var(--border-default);
  stroke-width: 0.5px;
`;

export const XAxisLine = styled.line`
  stroke: var(--border-default);
  stroke-width: 1px;
`;

export const AxisText = styled.text`
  ${typographyV2.bodyXs};
  fill: var(--text-soft);
  font-size: 14px;
`;

export const XAxisText = styled.text`
  ${typographyV2.bodyXs};
  fill: var(--text-soft);
  font-size: 14px;
`;
